var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(this.isLoading)?_c('div',{staticClass:"loader-bg"},[_c('div',{attrs:{"id":"loader"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }